@if ((card?.template?.gameplay?.type??'') === 'periodic') {
  <div class="gameplay__container__box periodic__container">
    <mat-card class="card__container">
      <mat-card-content class="card__content">
        <div class="header__container">
          <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
        </div>
        @if (question?.hasText) {
          <div
            class="text__content"
            [ngClass]="didAnswer ? 'endText' : 'questionText'"
            [innerHTML]="questionText() | safe: 'html'"
          ></div>
        }
        <ng-container [ngTemplateOutlet]="periodicTemplate"></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if (question?.hasText) {
    <div
      class="text__content"
      [ngClass]="didAnswer ? 'endText' : 'questionText'"
      [@headShake]="didAnswer && !isAnswer"
      (@headShake.start)="onAnimationStart($event)"
      (@headShake.done)="onAnimationDone($event)"
    >
      @if (!didAnswer) {
        <span [@fadeOutOnLeave] (@fadeOutOnLeave.done)="onAnimationDone($event)" [innerHTML]="bottomText() | safe: 'html'"></span>
      } @else if (isAnimationDone) {
        <span [@fadeInOnEnter] [innerHTML]="answerText() | safe: 'html'"></span>
      }
    </div>
  }
</ng-template>

<ng-template #periodicTemplate>
  <ol class="wrapper">
    @for (element of periodicElements; track element.symbol) {
      <li
        attr.data-element-group="{{ element.groupName }}"
        attr.data-group="{{ element.group }}"
        attr.data-period="{{ element.period }}"
        class="element {{ element.symbol | lowercase }}"
        [ngClass]="{
          dimmed: isDimmed(element),
          selected: isSelected(element),
          active: isActive(element),
          highlight: !didAnswer && !isSelected(element)
        }"
      >
        @if (didAnswer) {
          <div class="name">{{ element.name }}</div>
          <div class="symbol">{{ element.symbol }}</div>
        } @else {
          <div class="name" [style.visibility]="isNameVisible ? 'visible' : 'hidden'">
            {{ element.name }}
          </div>
          <div class="symbol" [style.visibility]="isSymbolVisible ? 'visible' : 'hidden'">
            {{ element.symbol }}
          </div>
        }
      </li>
    }
    <div
      class="element lanthanoid"
      data-element-group="lanthanoid"
      [ngClass]="{ dimmed: isDimmed() }"
    ></div>
    <div
      class="element actinoid"
      data-element-group="actinoid"
      [ngClass]="{ dimmed: isDimmed() }"
    ></div>
  </ol>
</ng-template>
